<template>
  <div class="notification_class">
    {{ notification }}
    <!-- <div class="overlayTest"></div> -->
  </div>
</template>
<script>
import { createChatBlitzar } from '@/graphql/mutations';
import grapqlSocket from '@/services/graphqlSocket.js';

export default {
  name: 'Notifications',
  data() {
    return {
      notification: 'teste',
      wsClient: null,
      audio: null,
      redirectTimer: null,
      accessConfig: null,
    };
  },
  methods: {
    treatGraphQLEvent(incoming) {
      console.log('TreatEvent', incoming);
      if (incoming.detail) this.receiveMessage(incoming.detail);
    },

    normalizeDestiny(rawDestiny) {
      const result = { name: '', params: {}, path: '', external: '' };
      if (!rawDestiny) return result;

      if (typeof rawDestiny === 'string') {
        const trimmed = rawDestiny.trim();
        if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
          try {
            const parsed = JSON.parse(trimmed);
            if (parsed && typeof parsed === 'object') {
              result.name = parsed.name || '';
              result.params = parsed.params || {};
              result.path = parsed.path || '';
              return result;
            }
          } catch (e) {
            console.warn('normalizeDestiny: JSON parse failed for string destiny', rawDestiny, e);
          }
        }
        if (trimmed.startsWith('http')) {
          result.external = trimmed;
          return result;
        }
        if (trimmed.startsWith('/')) {
          result.path = trimmed;
          return result;
        }
        // treat remaining strings as a route name
        result.name = trimmed;
        return result;
      }

      if (typeof rawDestiny === 'object') {
        // Handle objects that came from spreading a string (numeric keys)
        const keys = Object.keys(rawDestiny);
        const allNumeric = keys.length > 0 && keys.every((k) => String(parseInt(k)) === k);
        if (allNumeric) {
          let str = '';
          keys
            .sort((a, b) => a - b)
            .forEach((k) => {
              str += rawDestiny[k];
            });
          try {
            const parsed = JSON.parse(str);
            result.name = parsed.name || '';
            result.params = parsed.params || {};
            result.path = parsed.path || '';
            return result;
          } catch (e) {
            console.warn('normalizeDestiny: failed to parse reconstructed string', str, e);
          }
        }

        result.name = rawDestiny.name || '';
        result.params = rawDestiny.params || {};
        result.path = rawDestiny.path || '';
        if (rawDestiny.url && typeof rawDestiny.url === 'string' && rawDestiny.url.startsWith('http')) result.external = rawDestiny.url;
        if (rawDestiny.external && typeof rawDestiny.external === 'string') result.external = rawDestiny.external;
        return result;
      }

      return result;
    },

    async subscribeGraphQl() {
      this.wsClient = await grapqlSocket.subscribeGraphQl(this.$store.state, this.$store.state.eventId, null);
      console.log('wsclient=', this.wsClient);
      this.wsClient.addEventListener('treating', this.treatGraphQLEvent);
    },

    async connectWs() {
      if (this.accessConfig.graphQl) {
        await this.subscribeGraphQl();
      } else {
        //this.wsClient = new WebSocket('ws://localhost:3333');
        const token = this.$store.state.user.token;
        const template = this.$store.state.template;

        if (token.length > 0 && template.notificationConfig) {
          //? this.$store.state.user.token
          //: '3116d460-7cb1-11ea-bc55-0242ac130003';
          //this.wsClient = new WebSocket(`wss://mi0kxajewd.execute-api.us-east-1.amazonaws.com/prd?authToken=${token}`);
          //this.wsClient = new WebSocket('wss://ws.blitzar.com.br');
          this.wsClient = new WebSocket('wss://websocket.blitzar.com.br');
          //this.wsClient = new WebSocket('ws://localhost:3334');
          console.log('Conectando Notificação...');
          //this.wsClient = new WebSocket("wss://");
          this.wsClient.addEventListener('message', this.receiveMessage);
          this.wsClient.addEventListener('open', () => {
            console.log('Conectado Notificação');
            this.wsClient.send(
              JSON.stringify({
                type: 'subscribe',
                channel: this.$store.state.eventId,
              }),
            );
          });
          this.wsClient.addEventListener('close', () => {
            this.wsClient = null;
            setTimeout(this.connectWs, 3000);
          });
          this.wsClient.addEventListener('error', () => {
            console.error('ws error');
            this.wsClient.close();
          });
        }
      }
    },

    receiveMessage(incoming) {
      console.log('receiveMessage', incoming);
      let msg;
      try {
        msg = JSON.parse(incoming.data);
      } catch (e) {
        msg = incoming.data || incoming;
      }
      console.log('Notification MESSAGE:', msg);

      if (msg.type != 'begin-notification') return;

      let property = null;
      try {
        const propString = msg.notification.notification_property;
        if (propString && typeof propString === 'string') {
          property = JSON.parse(propString);
        }
      } catch (e) {
        console.warn('Failed to parse notification_property:', e);
        property = null;
      }

      const rawDestiny = msg.notification ? msg.notification.notification_destiny : null;
      const destiny = this.normalizeDestiny(rawDestiny);
      console.log('rawDestiny', rawDestiny);
      console.log('parsedDestiny', destiny);
      console.log('property', property, msg.notification ? msg.notification.notification_property : undefined);
      const routeParams = this.$route.params ? this.$route.params : { stream: '' };
      console.log('routeParams', routeParams);
      //if (this.$route.name === 'Home' || (routeParams.stream != '' && routeParams.stream === (destiny.params && destiny.params.stream))) return;

      if (msg.type == 'begin-notification') {
        console.log('LanguageFilter');
        // LANGUAGE FILTER
        if (msg.notification.language_code == null || msg.notification.language_code == this.$store.state.user.language) {
          console.log('begin-notification', msg);
          this.audio.play();

          let duration = null;

          if (property && property.auto_redirect) {
            if (destiny.external) {
              duration = Math.floor(Math.random() * 10000) + 5000;
              console.log('Scheduling window.open of', destiny.external, 'in', duration);
              this.redirectTimer = setTimeout(() => {
                console.log('Opening external URL', destiny.external);
                window.open(destiny.external);
              }, duration);
            } else if (destiny.name) {
              duration = Math.floor(Math.random() * 10000) + 5000;
              console.log('Scheduling redirect to route', destiny.name, 'in', duration, 'destiny:', destiny, 'property:', property);
              this.redirectTimer = setTimeout(() => {
                console.log('Executing queued router push to', destiny.name, 'params', destiny.params);
                this.$router
                  .push({
                    name: destiny.name,
                    params: destiny.params || {},
                  })
                  .catch((err) => console.error('Router push error:', err));
              }, duration);
            } else if (destiny.path) {
              duration = Math.floor(Math.random() * 10000) + 5000;
              console.log('Scheduling redirect to path', destiny.path, 'in', duration);
              this.redirectTimer = setTimeout(() => {
                console.log('Executing queued router push to path', destiny.path);
                this.$router.push({ path: destiny.path }).catch((err) => console.error('Router push error (path):', err));
              }, duration);
            }
          }

          this.$toasted.show(msg.notification.notification_message, {
            duration,
            action: {
              text: 'OK',
              onClick: (e, toastObject) => {
                console.log('Toast action clicked', destiny, rawDestiny);
                toastObject.goAway(0);

                if (duration) {
                  console.log('Clearing redirect timer before navigating');
                  clearTimeout(this.redirectTimer);
                }

                if (destiny.external) {
                  window.open(destiny.external);
                } else if (destiny.name) {
                  this.$router
                    .push({
                      name: destiny.name,
                      params: destiny.params || {},
                    })
                    .catch((err) => console.error('Router push error (toast):', err));
                } else if (destiny.path) {
                  this.$router.push({ path: destiny.path }).catch((err) => console.error('Router push error (toast path):', err));
                }
              },
            },
          });
        } else return;
      } else if (msg.type == 'end-notification') {
      }
    },
  },

  async mounted() {
    this.accessConfig = this.$store.state.template.accessConfig;
    this.audio = new Audio('https://www.redringtones.com/wp-content/uploads/2020/07/flute-sms-short-ringtone.mp3'); //('https://www.redringtones.com/wp-content/uploads/2016/09/icq-uh-oh.mp3');

    if (this.accessConfig.useGraphQL) {
      console.log('using GraphQL, websocket is not even called');
      this.subscribeGraphQl();
    } else if (!this.accessConfig.disableWS) await this.connectWs();
  },
  beforeDestroy() {
    if (!this.accessConfig.useGraphQL && this.wsClient) {
      try {
        this.wsClient.close();
        this.wsClient.send(
          JSON.stringify({
            payload: {},
            type: 'stop',
            //channel: this.$store.state.eventId,
          }),
        );
      } catch (error) {}
    }
  },
};
</script>

<style lang="scss">
.overlayTest {
  position: fixed;
  bottom: 20vh;
  left: 44vw;
  background-color: red;
  width: 200px;
  height: 200px;
  z-index: 100;
}
.notification_class {
  display: none;
}
.toasted-container {
  //margin-right: -4% !important;
  display: flex !important;
  position: fixed !important;
}
.toasted {
  background-color: #7c7c7c !important;
  color: transparent !important;
  color: #f9f9f9 !important;
  font-family: 'Lato' !important;
  font-size: 18px !important;
  justify-content: flex-end !important;
  border-radius: var(--input-borderRadius) !important;
  // border: 1px solid rgb(85, 78, 78) !important;
  max-width: 400px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.action {
  margin-left: 20px !important;
}
.action:nth-child(1) {
  background-color: transparent !important;
  color: white !important;
  text-decoration: none !important;
  //margin-left: -12px !important;
}
.action:nth-child(2) {
  background-color: #343434 !important;
  color: white !important;
  text-decoration: none !important;
}
.action:nth-child(3) {
  background-color: #343434 !important;
  color: white !important;
  text-decoration: none !important;
}
@media only screen and (max-width: 600px) {
  .toasted-container {
    min-width: 20% !important;
    margin-right: 10px !important;
  }
  .toasted-container .toasted:first-child {
    margin-top: 80px !important;
  }
}
</style>
